import React from "react";
import PrintLink from './PrintLink';
import Grid from '@material-ui/core/Grid';
import ReportFileUploader from "./ReportFileUploader";
import MaterialDatePicker from './MaterialDatePicker';
import * as agent from "../agent";


class Reports extends React.Component {
    state = {
        startDate: new Date(new Date().getFullYear(), new Date().getMonth(), 1),
        endDate: new Date(),
    };

    onStartDateChange = date => {
        this.setState({ startDate: new Date(date) });
    }
    onEndDateChange = date => {
        this.setState({ endDate: new Date(date) });
    }

    render() {
        const { startDate, endDate } = this.state;
        const sD = startDate.valueOf();
        const eD = endDate.valueOf();
        const { userPermissions } = this.props;
        return (
            <div style={{ overflow: "hidden" }}>
                <Grid container justify="flex-start" spacing={32} >
                    <Grid item>
                        <Grid item container justify="flex-start" spacing={8}>
                            <Grid item>
                                <MaterialDatePicker label="Начало периода" value={startDate} onChange={this.onStartDateChange} />
                            </Grid>
                            <Grid item>
                                <MaterialDatePicker label="Конец периода" value={endDate} onChange={this.onEndDateChange} />
                            </Grid>
                        </Grid>
                        <Grid item className="wide-column common-form">
                            {userPermissions.includes("bookkeeping") && <PrintLink href={agent.src.printReport("report", sD, eD)} label="Отчет 1" />}
                            {userPermissions.includes("bookkeeping") && <PrintLink href={agent.src.printReport("report2", sD, eD) } label="Отчет 2" />}
                            {userPermissions.includes("bookkeeping") && <PrintLink href={agent.src.printReport("phonecalls", sD, eD) } label="Отчет по звонкам" />}
                            {userPermissions.includes("bookkeeping") && <PrintLink href={agent.src.printReport("finance", sD, eD) } label="Отчет по финансам" />}
                            {userPermissions.includes("bookkeeping") && <PrintLink href={agent.src.printReport("staff", sD, eD) } label="Отчет по персоналу" />}
                            {userPermissions.includes("bookkeeping") && <PrintLink href={agent.src.printReport("balance", sD, eD) } label="Оборотная ведомость" />}
                        </Grid>
                    </Grid>
                    <Grid item >
                        <ReportFileUploader />
                    </Grid>
                </Grid>
            </div>
        )
    }
}

export default Reports;



// WEBPACK FOOTER //
// ./src/components/Reports.js